export const scrollTop= function (){
    const bodys = document.getElementsByClassName('scroll')[0]
    bodys.scroll(0,0)
}
